import catVarc from "./CatVarc";
import catDilr from "./CatDilr";
import catQa from "./CatQa";
import catMock2Varc from "./mock2/CatVarc";
import catMock2Dilr from "./mock2/CatDilr";
import catMock2Qa from "./mock2/CatQa";
import catMock3Varc from "./mock3/CatVarc";
import catMock3Dilr from "./mock3/CatDilr";
import catMock3Qa from "./mock3/CatQa";
import catMock4Varc from "./mock4/CatVarc";
import catMock4Dilr from "./mock4/CatDilr";
import catMock4Qa from "./mock4/CatQa";
import catMock5Varc from "./mock5/CatVarc";
import catMock5Dilr from "./mock5/CatDilr";
import catMock5Qa from "./mock5/CatQa";
import catMock6Varc from "./mock6/CatVarc";
import catMock6Dilr from "./mock6/CatDilr";
import catMock6Qa from "./mock6/CatQa";
import catMock7Varc from "./mock7/CatVarc";
import catMock7Dilr from "./mock7/CatDilr";
import catMock7Qa from "./mock7/CatQa";

// Question sets per CAT mock. Every mock follows CAT_CONFIG (same sections and
// id ranges), so only the questions differ.
const CAT_MOCKS = {
  1: { varc: catVarc, dilr: catDilr, qa: catQa },
  2: { varc: catMock2Varc, dilr: catMock2Dilr, qa: catMock2Qa },
  3: { varc: catMock3Varc, dilr: catMock3Dilr, qa: catMock3Qa },
  4: { varc: catMock4Varc, dilr: catMock4Dilr, qa: catMock4Qa },
  5: { varc: catMock5Varc, dilr: catMock5Dilr, qa: catMock5Qa },
  6: { varc: catMock6Varc, dilr: catMock6Dilr, qa: catMock6Qa },
  7: { varc: catMock7Varc, dilr: catMock7Dilr, qa: catMock7Qa }
};

export const getCatMock = (mock) => CAT_MOCKS[mock] || CAT_MOCKS[1];

// Mock 1 keeps its original route and saved test name.
export const catPath = (mock) => (mock > 1 ? `/quiz/cat-mock${mock}` : "/quiz/cat");
export const catTestName = (mock) => (mock > 1 ? `CAT Mock Test ${mock}` : "CAT Mock Test");

export const getCatQuestions = (mock) => {
  const m = getCatMock(mock);
  return [...m.varc, ...m.dilr, ...m.qa];
};
